module.exports = __webpack_public_path__ + "img/11_105.a455741a.png";